<template>
	<article
		:id="id"
		:class="[labelClass, 'dc-post-grid-card', 'location-card']"
		v-on:click.meta.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.ctrl.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.exact.stop.prevent="goToPost('click')"
	>
		<div ref="cardContentWrapper" class="card-content">
			<h3 v-if="title" class="card-title">{{ title }}</h3>
			<p v-if="address" class="card-address">{{ address.address }}</p>
			<p v-if="phone" class="card-phone">
				<a :href="formattedPhone.href">{{ formattedPhone.str }}</a>
			</p>
			<p v-if="email" class="card-email">
				<a :href="'mailto:' + email">{{ email }}</a>
			</p>
			<dc-button :url="url" :aria-label="`Go to location: ${title}`" />
		</div>
	</article>
</template>

<script>
import Post from './Post';
import PhoneNumber from 'awesome-phonenumber';

export default {
	extends: Post,
	props: {
		title: {
			type: String,
			required: true,
		},
		address: {
			type: String,
			required: true,
		},
		phone: {
			type: String,
			required: true,
		},
		email: {
			type: String,
			required: true,
		},
	},
	computed: {
		formattedPhone() {
			const phone = new PhoneNumber('+' + this.phone);
			return {
				href: 'tel:' + phone.getNumber(),
				str: phone.getNumber('international'),
			};
		},
	},
};
</script>
